export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeTab: null,
      selectedItem: {}
    }
  },
  methods: {
    syncUrl() {
      //window.location.hash = this.activeTab+1;
    },
    async handleDelete() {
      if (await this.deleteFunc(this.selectedItem)) {
        this.$router.push({ name: this.home });
      }
    },
    async fetch() {
      let res=this.operationWithCheck(await this.fetchFunc(this.id));
      if (res) {
        this.selectedItem=res;
        this.detailsTitle=this.title(this.selectedItem);
      }
    },
  },
  created() {
    if (window.location.hash.includes("#")) {
      let splt=window.location.hash.split("#");
      let myIndex=splt[splt.length-1];
    this.activeTab = parseInt(myIndex)-1;
    }
    this.fetch();
  }
}